<template>
  <div class="h-full flex flex-col">
    <div class="flex justify-center border-solid border-b border-grey-100 pb-2 bg-white">

      <button v-if='isAddingToRoot' :class="setupTransformsTypeClasses" @click='step > 0 && selectStep(0)'>
        <div class="pbc-add-step-subtext">Adding to</div>
        <div class="pbc-add-step-title">{{partutil.from.name}}</div>
      </button>
      <button v-else :class='setupTransformsTypeClasses' @click='step > 0 && selectStep(0)' >
        <div class="pbc-add-step-subtext">Adding to</div>
        <div class="flex justify-center" v-for='parent in addingToParents' :key='parent.transform.id'>
          <inline-render :transform='parent' :from='transformsAndSource.from' :gamedata='partutil.gamedata' :source='transformsAndSource.source' />
        </div>
      </button>


      <button @click='selectStep(1)' :class="setupComponentClasses" :disabled='step <= 2'>
        <div class="pbc-add-step-subtext">Setup</div>
        <div class="pbc-add-step-title">{{addedComponentTitle}}</div>
      </button>


      <button v-if='!skipFunky && numSteps > 2' @click='selectStep(2)' :class="setupFunkyClasses" :disabled='step <= 1'>
        <div class="pbc-add-step-subtext">When</div>
        <div class="pbc-add-step-title">?</div>
      </button>


      <button v-if='numSteps > 3' :class="setupChildComponentClasses" :disabled='step !== 1'>
        <div class="pbc-add-step-subtext">{{addingChildrenTitle}}</div>
        <div class="pbc-add-step-title">Setup</div>
      </button>
    </div>

    <apollo-query v-if='step === 0' 
                  :query='getToysQuery'
                  :variables='{from, size,public:true}'
                  fetch-policy='cache-and-network'
                  class="add-main-area">
      <template v-slot='{ result: { loading, error, data }, isLoading }'>
        <div v-if='isLoading || loading' class="spinner text-xl mt-8 mb-4" />
        <add-transforms class="add-main-area" @add='create' @next='$emit("next")' :toys='(data && data.getToys) ? data.getToys.items : []' />
      </template>
    </apollo-query>


    <div class="add-main-area" v-else-if='step === 1'>
      <component-details v-for='(newComponent, i) in newComponents'
                        :key='newChildren[i].id'
                        :transform='newChildren[i]'
                        :transforms-and-source='transformsAndSource'
                        :disable-toolbar-buttons='true'
                        :initial='true'
                        :partutil='partutil'
                        @validated='onValidated'
                        @autofinish='onAutoFinish'
                        :component='newComponent' />
    </div>

    <choose-funky class="add-main-area" v-if='step === 2' @add="chooseFunkyType" @next='$emit("next")' />

    <div class="add-main-area text-xs bg-gray-900" v-else-if='step === 3'>
      <div v-for='(newChild,i) in newChildren' :key='newChild.id'>
        <component v-if='childrenComponents[i]' 
                  :is='childrenComponents[i]' 
                    :transform='newChildren[i]'
                    :parent-transform='addingToParents[i]'
                    :component='newComponents[i]'
                    :partutil='partutil'
                    :transforms-and-source='transformsAndSource'
                  />
      </div>
    </div>
  </div>
</template>
<script>
import Toydata from '@edit/tree/toydata.js';
import Partutil from '@edit/tree/partutil.js';
import { ApolloQuery } from 'vue-apollo';
import gql from 'graphql-tag';
const getToysQuery = gql(`
  query getToys($from: Int!, $size: Int!, $public: Boolean) {
    getToys(from: $from, size: $size, public: $public) {
      items {
        id,
        name,
        description,
        thumbnailImage,
        toy
      }
    }
  }
`);


import { range, cloneDeep, merge } from 'lodash';
import InlineRender from '@edit/atoms/InlineRender.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import AddTransforms from '@ui/organisms/AddTransforms.vue';
import ChooseFunky from '@ui/organisms/ChooseFunky.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';

import OnEventOverlay from '@ui/molecules/OnEventOverlay.vue';
import RandomOverlay from '@ui/molecules/RandomOverlay.vue';
import SpawnerOverlay from '@ui/molecules/SpawnerOverlay.vue';
import DelayOverlay from '@ui/molecules/DelayOverlay.vue';
export default {
  props: {
    addingToParents: {
      type: Array,
      required: true
    },
    addingToChildrenComponents: {
      type: Array,
      default() {
        return []
      }
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    skipFunky: {
      type: Boolean,
      required: false
    }
  },
  data() {
    const numSteps = (this.skipFunky ? 3 : (this.addingToChildrenComponents.length ? 3 : 3));
    return {
      step: 0,
      newComponents: [],
      newChildren: [],
      //childrenComponents:[...this.addingToChildrenComponents],
      childrenComponents:[],
      numSteps,
      getToysQuery,
      from: 0,
      size: 100
    }
  },
  methods: {
    next() {
      this.selectStep(this.step + 1);
    },
    chooseFunkyType({type}) {
      this.funkyType = type;
      this.$emit('validate-step', true);
      if (type !== 'immediate') {
        this.numSteps = 3;

        this.createWithFunky();

        const childComponent = {
          'onEventTransform':OnEventOverlay,
          'delayTransform':DelayOverlay,
          'spawner':SpawnerOverlay,
          'randomTransform':RandomOverlay
        }[type];
        this.childrenComponents.push(childComponent);
        this.$emit("change-step", this.step, this.numSteps);
      } else {
        this.numSteps = 3;
        this.$emit("change-step", this.step, this.numSteps);
      }
    },
    createFromComponent(type) {
      this.typeToCreate = type;
      const newComponent = ComponentsDb.types[this.typeToCreate].createNew();
      const {
        newChildren,
        newParents,
        newComponents
      } = this.partutil.addChildren(this.addingToParents, newComponent);

      this.newChildren = newChildren;
      this.newParents = newParents;
      this.newComponents = newComponents;


      this.componentsChosen = newComponents;
      this.childrenChosen = newChildren;

    },
    createFromToy(in_toy, in_parents) {
      if (this.skipFunky) {
        this.numSteps = 2;
        this.$emit("change-step", this.step, this.numSteps);
      }

      const parents = [...in_parents];
      const toy = cloneDeep(in_toy);
      this.typeToCreate = 'toy';
      this.createdFromToy = cloneDeep(toy);

      const toydata = new Toydata(this.partutil.from.layers, cloneDeep(toy));
      const toyPartutil = new Partutil(toydata.getTransformsAndSource());
      toyPartutil.selectLayer(this.partutil.selectedLayer);
      const toDuplicate = [];
      parents.forEach( (parent) => {
        toy.transforms.forEach( (transform) => {
          toDuplicate.push({parent:cloneDeep(parent), child:transform});
        });
      });
      const {
        addedChildren: toyChildren,
        addedComponents: toyComponents,
        addedLinks: toyLinks
      } = toyPartutil.duplicateChildren(toDuplicate);

      const duplicatedParents = range(toyChildren.length).map( () => {
        // TODO: huh??
        // what if there are multiple parents?
        return parents[0];
      });
      const {
        addedChildren: newChildren,
        addedParents: newParents,
        addedComponents: newComponents
      } = this.partutil.addTransformsAndStuff(duplicatedParents, toyChildren, toyComponents, toyLinks);

      this.newChildren = newChildren;
      this.newParents = newParents;
      this.newComponents = newComponents;

      this.componentsChosen = newComponents;
      this.childrenChosen = newChildren;
    },
    create({type}) {
      // omg, i am so sorry :-(
      this.undo();
      if (type.indexOf('{') === -1) {
        this.createFromComponent(type);
      } else {
        this.createFromToy(JSON.parse(type), this.addingToParents);
      }
      console.log('validate-step', true);
      this.$emit('validate-step', true);
      //this.step++;
    },
    onValidated(nv) {
      //this.$emit('validated-component-setup', nv);
      console.log('on validated!?!?!?!', nv);
      this.$emit('validate-step', nv);
    },
    onAutoFinish() {
      console.log('auto finish');
      this.$emit('next');
    },
    selectChildren(children, parents, components) {
      if (this.typeToCreate !== 'toy') {
        this.$emit('select-children', {
          children,
          parents,
          components
        });
      } else {
        this.$emit('select-children', {
          children:[children[0]],
          parents:[parents[0]],
          components:[components[0]]
        });
      }
    },
    positionChildren(children, parents) {
      if (this.typeToCreate !== 'toy') {
        this.$emit('position-children', {
          children,
          parents
        });
      } else {
        this.$emit('position-children', {
          children:[children[0]],
          parents:[parents[0]]
        });
      }
    },
    done() {
      if (this.funkyType === 'immediate') {

        this.$emit('add-children', {
          newChildren:this.newChildren,
          newParents:this.newParents,
          newComponents:this.newComponents
        });
        this.selectChildren(this.newChildren, this.newParents, this.newComponents);
        this.positionChildren(this.newChildren, this.newParents);
        return;
      } else {

        this.addedChildren.forEach( ({transform}) => {
          transform.pos.x = 0;
          transform.pos.y = -1;
        });

        this.$emit('add-children', {
          newChildren:this.newChildren,
          newParents:this.newParents,
          newComponents:this.newComponents
        });

        this.selectChildren(this.addedChildren, this.addedParents, this.addedComponents);
        this.positionChildren(this.funkyChildren, this.funkyParents);
      }

    },
    createWithFunky() {
      const oldComponents = cloneDeep(this.componentsChosen);
      const oldChildren = cloneDeep(this.childrenChosen);
      this.undo();

      const funkyComponent = ComponentsDb.types[this.funkyType].createNew();
      const funkyVars = ComponentsDb.types[this.funkyType].createChild();

      const {
        newChildren:funkyChildren,
        newParents:funkyParents,
        newComponents:funkyComponents
      } = this.partutil.addChildren(this.addingToParents, funkyComponent);

      funkyChildren.forEach( (funkyChild) => {
        funkyChild.transform.zIndex = 0;
      });

      let newChildren, newParents, newComponents;
      if (this.typeToCreate !== 'toy') {
        const newComponent = ComponentsDb.types[this.typeToCreate].createNew();
        const data = this.partutil.addChildren(funkyChildren, newComponent);
        newChildren = data.newChildren;
        newParents = data.newParents;
        newComponents = data.newComponents;
      } else {
        this.createFromToy(cloneDeep(this.createdFromToy), funkyChildren);

        newChildren = this.newChildren;
        newParents = this.newParents;
        newComponents = this.newComponents;
      }

      // Copy the old component, because user has changed it in previous screen.
      oldComponents.forEach( (oldComponent, i) => {
        delete oldComponent.id;
        Object.assign(newComponents[i], oldComponent);
      });
      // Also copy transform, because it was changed by sprite loading to scale
      // the image in the previous step.
      oldChildren.forEach( (oldChild, i) => {
        merge(newChildren[i].transform, oldChild.transform);
      });

      newChildren.forEach( (newChild) => {
        merge(newChild, funkyVars);
      });

      this.addedChildren = newChildren;
      this.addedComponents = newComponents;
      this.addedParents = newParents;

      this.funkyChildren = funkyChildren;
      this.funkyComponents = funkyComponents;
      this.funkyParents = funkyParents;

      this.newChildren = newChildren.concat(funkyChildren);
      this.newComponents = newComponents.concat(funkyComponents);
      this.newParents = newParents.concat(funkyParents);

    },
    selectStep(step) {
      console.log('select step', step);
      this.step = step;
      if (step >= 2 && this.skipFunky) {
        //console.log('validate and finish');
        this.chooseFunkyType({type:'immediate'});
        this.$emit('next');
        return;
      }
        //return;
        //this.$emit("validate-step", true);
        //this.$emit('next');
      //}

      if (step < 3) {
        this.$emit("validate-step", false);
      }
    },
    undo() {
      if (!this.newComponents.length) {
        return;
      }
      // we need to remove what we already added
      // the user is going back a step
      const multipleTransforms = [];
      for (let i = 0; i < this.newChildren.length; i++) {
        multipleTransforms.push({
          parent:this.newParents[i],
          child:this.newChildren[i]
        });
      }
      this.partutil.removeTransforms(multipleTransforms);
      this.partutil.internalRemoveComponentsAndLinks(this.newComponents, []);
      this.newComponents = [];
      this.newChildren = [];
      this.newParents = [];

      this.addedComponents = [];
      this.addedChildren = [];
      this.addedParents = [];

      this.funkyComponents = [];
      this.funkyChildren = [];
      this.funkyParents = [];

    }
  },
  components: {
    AddTransforms,
    ComponentDetails,
    ChooseFunky,
    InlineRender,
    ApolloQuery
  },
  computed:{
    setupTransformsTypeClasses() {
      if (this.step === 0) {
        return ['pbc-add-step-active'];
      } else {
        return ['pbc-add-step-completed'];
      }
    },
    setupFunkyClasses() {
      if (this.step < 2) {
        return ['pbc-add-step-waiting'];
      } else {
        if (this.step === 2) {
          return ['pbc-add-step-active'];
        } else {
          return ['pbc-add-step-completed'];
        }
      }
    },
    setupComponentClasses() {
      if (this.step < 1) {
        return ['pbc-add-step-waiting'];
      } else {
        if (this.step === 1) {
          return ['pbc-add-step-active'];
        } else {
          return ['pbc-add-step-completed'];
        }
      }
    },
    setupChildComponentClasses() {
      if (this.step === 2) {
        return ['pbc-add-step-active'];
      } else {
        return ['pbc-add-step-waiting'];
      }
    },
    isAddingToRoot() {
      return this.addingToParents.filter( (parent) => {
        return parent === this.partutil.root;
      }).length === this.addingToParents.length;
    },
    hasChildrenComponents() {
      return this.addingToChildrenComponents.filter( (cc) => {
        return !!cc;
      }).length > 0;
    },
    addingChildrenTitle() {
      if (this.hasChildrenComponents) {
        const activeChildrenComponents = this.addingToChildrenComponents.map( (data,i) =>{
          return [data,i];
        }).filter( ([data, i]) => {
          return !!data;
        });
        const firstChildrenTransformIdx = activeChildrenComponents[0][1]
        const firstTransform = this.addingToParents[firstChildrenTransformIdx];
        const component = this.partutil.findComponentForTransform(firstTransform);
        return ComponentsDb.types[component.type].text + (activeChildrenComponents.length > 1 ? (" + more") : '');
      } else {
        return '?';
      }
    },
    addedComponentTitle() {
      if (this.newComponents.length) {
        if (this.typeToCreate !== 'toy') {
          return ComponentsDb.types[this.newComponents[0].type].text;
        } else {
          return 'Toy';
        }
      } else {
        return '?';
      }
    },
  },
  watch:{
    step: {
      handler(nv, ov) {
        console.log('STEP HANDLER', nv, this.numSteps);
        if (nv === 1 && this.typeToCreate === 'toy') {
          this.$emit("validate-step", true);
          this.$emit('next');
          return;
        }
        this.$emit("change-step", nv, this.numSteps);
        if (nv < 2) {
          this.$emit('validated-setup', false);
          this.$emit("validate-step", false);
        }
        if (nv !== ov) {
          if (nv === 0) {
            this.undo();
          }
        }
      },
      immediate: true
    }
  }
}
</script>
